import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from './components/Header';
import AddLeadPopup from './components/AddLeadPopup';
import axios from 'axios';
import TableLoader from './components/TableLoader';

const CallerReport = () => {
    const [toggleLeadPopup, setToggleLeadPopup] = useState(0);
    const [userDetails, setUserDetails] = useState([]);
    const [filterStatus, setfilterStatus] = useState("");

    const [clientData, setClientData] = useState([]);
    const [tableLoader, setTableLoader] = useState(0);

    const [date, setDate] = useState("");

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const url = window.url;
    const qry = new FormData();

    const fullDate = new Date();

    const navigate = useNavigate();

    useEffect(() => {
        // setTableLoader(1);
        if (localStorage.getItem("user")) {
            const userData = JSON.parse(localStorage.getItem("user"));
            setUserDetails(userData);
            // console.log(userData);
            if (userData.designation == "A" || userData.designation == "D" || userData.designation == "F") {

            }
            else {
                navigate("/");
            }
            qry.append("emp_id", userData.user_id);
            // console.log(userData.user_id);

        }
        // fetchMyLeadsApi("");
    }, []);

    const reload = () => {
        qry.append("emp_id", userDetails.user_id);
        fetchMyLeadsApi();
    }

    const changeFilter = (e) => {
        qry.append("emp_id", userDetails.user_id);
        setfilterStatus(e);
        fetchMyLeadsApi(e);
        // console.log(e.target.value);
    }

    const fetchMyLeadsApi = (e) => {
        setTableLoader(1);
        // qry.append("calling_date", e);
        qry.append("emp_id", userDetails.user_id);
        qry.append("from_date", fromDate);
        qry.append("to_date", toDate);

        axios.post(url + "fetch-caller-report.php", qry).then((response) => {
            if (response.data.status == 1) {
                // response.data.data.sort(function(a,b){
                //     return a.next_follow_time - b.next_follow_time;
                // });
                setClientData(response.data);
                // setDate(response.data.date);
            }

            // console.log(response.data);

            setTableLoader(0);
        }).catch(error => {
            console.log("error");
        });
    }




    const closeLeadPopup = () => {
        setToggleLeadPopup(0);
    }

    const fetchData = () => {
        // console.log("data");
        if (fromDate == "" || toDate == "") {
            alert("please select date range then submit!");
        } else {
            fetchMyLeadsApi();
        }
    }


    var i = 0;
    const index = () => {
        i = i + 1;
    }

    const updateFromDate = (e) => {
        setFromDate(e);
        // console.log(e);
        // console.log(fullDate.getFullYear() + "-" + String(fullDate.getMonth() + 1).padStart(2, '0') + "-" + String(fullDate.getDate()).padStart(2, '0'))
        if (e == (fullDate.getFullYear() + "-" + String(fullDate.getMonth() + 1).padStart(2, '0') + "-" + String(fullDate.getDate()).padStart(2, '0'))) {
            setToDate(e);
        }
    }

    return (
        <>


            <Header />

            <div className='container-head report-container-head'>
                <div className='report-filter'>
                    <div>
                        <h2> From </h2>
                        <div className='filter'>

                            {/* <select onChange={(e) => setfilterStatus(e.target.value)}>
                            <option value=""> Filter Status</option>
                            <option value="Follow Up"> Follow Up</option>
                            <option value="Visiting"> Visiting </option>
                            <option value="Visited"> Visited</option>
                        </select> */}

                            <input type='date' onChange={(e) => updateFromDate(e.target.value)} max={fullDate.getFullYear() + "-" + String(fullDate.getMonth() + 1).padStart(2, '0') + "-" + String(fullDate.getDate()).padStart(2, '0')} value={fromDate} />
                            {/* &nbsp;
                        <input type='time' onChange={(e) => changeFilter(e.target.value)} /> */}
                            {/* <i className='fa fa-calendar' onClick={() => changeFilter("")}></i> */}
                            {/* <input type='date' /> */}
                        </div>
                    </div>


                    <div className='filter'>
                        <div>
                            <h2> To </h2>
                            &nbsp; &nbsp; &nbsp;

                            <input type='date' onChange={(e) => setToDate(e.target.value)} min={fromDate} max={fullDate.getFullYear() + "-" + String(fullDate.getMonth() + 1).padStart(2, '0') + "-" + String(fullDate.getDate()).padStart(2, '0')} value={toDate} />
                            {/* &nbsp;
                        <input type='time' onChange={(e) => changeFilter(e.target.value)} /> */}
                            {/* <i className='fa fa-calendar' onClick={() => changeFilter("")}></i> */}
                            {/* <input type='date' /> */}
                        </div>

                    </div>
                    <div>
                        &nbsp; &nbsp;
                        <button onClick={() => fetchData()} className='crm-btn-primary'> Submit </button>
                    </div>
                </div>

                <div>

                </div>
            </div>

            <div className='crm-container report-container'>

                <div className="caller-report-container">
                    <div>
                        {/* <div>
                            <p>Total Call : 100 </p>
                            <p>Connectd : 20 </p>
                        </div>
                        <div>
                            <p>Not Respond : 80 </p>
                            <p>Ready to Sign : 0 </p>
                        </div>
                        <div>
                            <p>Not Interested : 0 </p>

                        </div> */}


                        <table>
                            {clientData.length != [] ?
                                <>


                                    {/* {clientData.response_tags['call_back']}; */}

                                    {
                                        Object.entries(clientData.response_tags).map(([key, value]) => {
                                            return (<>
                                                {/* <div>
                                                    <p>{key}</p>
                                                    <p>{value}</p>
                                                </div> */}

                                                <tr>
                                                    <td className="td-left"><p>{key}</p></td>
                                                    <td><p>{value}</p></td>
                                                </tr>
                                            </>);
                                        })
                                    }


                                </>
                                : <>
                                    <tr><td colspan="">Please select date range and submit! </td></tr>
                                </>

                            }
                        </table>

                    </div>
                </div>
                {tableLoader == 1 ?

                    <TableLoader />
                    :
                    <>
                        <div style={{ "margin-top": "0px" }} className='crm-table visible-hide'>

                            <table>
                                <thead>
                                    <tr> <th> S No</th> <th> Calling Date/Time </th> <th> Name </th>  <th> Business Name </th> <th> Phone </th> <th> Lead For </th><th>Number of Calls</th> <th> Status </th> <th> Action </th></tr>
                                </thead>

                                {
                                    clientData.length != [] ?
                                        <>
                                            {
                                                clientData.total_leads.map((data) => {
                                                    index();
                                                    return (
                                                        <tr><td> {i}</td> <td>{data.calling_date} / {data.calling_time}</td> <td>{data.name}</td> <td>{data.business_name}</td> <td> {data.phone} </td> <td>{data.work}</td><td>{data.number_of_calls}</td> <td className='crm-color-primary'> {data.process_status == 1 ? "" : data.process_status == 2 ? "" : data.process_status == 3 ? "Follow Up" : data.process_status == 4 ? "R2-Sign" : data.process_status == 5 ? "Signed Up" : data.process_status == 6 ? "Closed" : data.process_status == 7 ? "Payment Done" : data.process_status == 8 ? "Not Interested" : ""} ({data.status_tag}) </td> <td> <Link to={'/view-lead-details/' + data.id}>View </Link> </td></tr>
                                                    );
                                                })
                                            }
                                        </>
                                        : <><tr><td>Empty</td></tr></>
                                }
                            </table>
                        </div>

                        <div className='crm-phone-table hide-visible'>
                            <p style={{ "display": "none" }}>{i = 0}</p>
                            {
                                clientData.length != [] ?
                                    <>
                                        {clientData.total_leads.map((data) => {
                                            index();
                                            return (
                                                <>
                                                    <div className='phone-table-item'>
                                                        <div className='table-item-left'>
                                                            <h2> {i} </h2>
                                                        </div>
                                                        <div className='table-item-right'>
                                                            <div>
                                                                <h2>{data.name}</h2>
                                                            </div>
                                                            <div>
                                                                <h2>{data.business_name}</h2>
                                                            </div>
                                                            <div>
                                                                <h2>{data.phone} </h2>

                                                            </div>
                                                            <div>
                                                                <p> {data.email} </p>
                                                            </div>
                                                            <div>
                                                                <p> Calling Date: {data.calling_date} / {data.calling_time} </p>
                                                            </div>
                                                            <div>
                                                                <p>Number of Calls: {data.number_of_calls}</p>
                                                            </div>
                                                            <div>
                                                                <p className='crm-color-primary'>
                                                                    {data.process_status == 1 ? "" : data.process_status == 2 ? "" : data.process_status == 3 ? "Follow Up" : data.process_status == 4 ? "R2-Sign" : data.process_status == 5 ? "Signed Up" : data.process_status == 6 ? "Closed" : data.process_status == 7 ? "Payment Done" : data.process_status == 8 ? "Not Interested" : ""} ({data.status_tag})
                                                                </p>
                                                                <Link to={'/view-lead-details/' + data.id}>View </Link>
                                                            </div>

                                                            <div className='lead-for'>
                                                                <span>Lead for: {data.work}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            );
                                        })
                                        }
                                    </>
                                    : <><tr><td>Empty</td></tr></>
                            }
                        </div>

                    </>
                }
            </div>
        </>
    )
}

export default CallerReport;